// extracted by mini-css-extract-plugin
export default {"umbrella":"Umbrella_umbrella__ThslP","login-slidein-right-to-left":"Umbrella_login-slidein-right-to-left__LwpdF","dim":"Umbrella_dim__JUdko"};